<template>
  <div :class="['fixed-footer']">
    <div class="fixed-footer--left">
    <template v-if="typeDocumentTemplate">
      <BasicButton
        :label="TypeDocumentTemplateLibelle[typeDocumentTemplate]"
        size="small"
        @click="$emit('printDocumentTemplate')"
        icon-name="print"
        iconRight
        class="fixed-footer__imprimer fixed-footer__imprimer--desktop"
      />


      <BasicButton
        size="small"

        @click="$emit('printDocumentTemplate')"
        icon-name="print"
        class="fixed-footer__imprimer tablet-none desktop-none"
      />

      <BasicTooltip v-if="typeDocumentTemplate === 'ProForma'" label="Glossaire">
          <BasicButton
            @click="redirectExterne('https://ressourcesstatiques.akto.fr/guide/v2/GlossaireProformaGroupee.xlsx')"
            size="small"
            icon-name="document-text"
            variant="outlined"
          />
        </BasicTooltip>
    </template>

    </div>
    <div class="fixed-footer--right">
      <template v-if="mustConfirm">
        <BasicButton
          label="Reprendre la saisie de la demande"
          size="small"
          @click="$emit('accept')"
        />
        <BasicButton
          label="Refuser la demande"
          type="danger"
          variant="outlined"
          size="small"
          @click="$emit('refuse')"
        />
      </template>
      <template v-else>
        <BasicButton
          label="Enregistrer"
          size="small"
          @click="$emit('save')"
        />
        <BasicButton
          label="Transmettre"
          type="reverse"
          variant="outlined"
          size="small"
          @click="$emit('transmit')"
        />
        <BasicButton
          v-if="canRefuse"
          label="Refuser"
          type="danger"
          variant="outlined"
          size="small"
          @click="$emit('refuse')"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { TypeDocumentTemplateLibelle, type TypeDocumentTemplate } from '@/features/domaine/types/opco/shared/TypeDocumentModele';
import { redirectExterne } from '@/features/shared/tools';


  defineProps<{ mustConfirm: boolean; canRefuse: boolean, typeDocumentTemplate:TypeDocumentTemplate| null }>()
  defineEmits(['save', 'transmit','printDocumentTemplate', 'accept', 'refuse'])
</script>

<style scoped lang="less">
  @import './DemandeFooter.less';
</style>
